export var ExpenseCategory;
(function (ExpenseCategory) {
    ExpenseCategory["FOOD"] = "FOOD";
    ExpenseCategory["TRANSPORT"] = "TRANSPORT";
    ExpenseCategory["HOUSING"] = "HOUSING";
    ExpenseCategory["ENTERTAINMENT"] = "ENTERTAINMENT";
    ExpenseCategory["HEALTH"] = "HEALTH";
    ExpenseCategory["FINANCIAL"] = "FINANCIAL";
    ExpenseCategory["INVESTMENT"] = "INVESTMENT";
    ExpenseCategory["SHOPPING"] = "SHOPPING";
    ExpenseCategory["BILLS"] = "BILLS";
    ExpenseCategory["OTHER"] = "OTHER";
})(ExpenseCategory || (ExpenseCategory = {}));
//# sourceMappingURL=expense.types.js.map